import {Button} from '@wandb/components';
import * as React from 'react';
import {useParams} from 'react-router';

import {trackObservabilityRunIssuesButton} from '../../../services/analytics/observabilityEvents';
import {useIssuesContext} from '../../../state/issues/IssuesContext';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';

export const RunIssuesButton = () => {
  const {activeIssues = [], activeErrorDrawer} = useIssuesContext();
  const {toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  const {entityName, projectName} = useParams<{
    entityName: string;
    projectName: string;
  }>();
  return (
    <Button
      startIcon="warning"
      onPress={() => {
        trackObservabilityRunIssuesButton({
          action: 'Click run issues button',
          entityName: entityName ?? '',
          projectName: projectName ?? '',
        });
        toggleWorkspaceDrawer('run-issues');
      }}
      variant="secondary">
      {activeErrorDrawer ? 'Issues' : `Issues (${activeIssues.length})`}
    </Button>
  );
};
